export default __webpack_public_path__ + "static/media/social-media-big.0e51edd7.gif";